import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class CookieService {
	setCookie(name: string, value: string, expiry: Date): void {
		const expires = `expires=${expiry.toUTCString()}`;
		document.cookie = `${name}=${value}; ${expires}; path=/`;
	}

	getCookie(name: string): string | null {
		const cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();
			if (cookie.startsWith(name + '=')) {
				return cookie.substring(name.length + 1);
			}
		}
		return null;
	}

	deleteCookie(name: string): void {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
	}
}
